export default __webpack_public_path__ + "media/website/marker-28932c55d09728d841f837d185019a1e.png";